import {SODeleteConstraint} from '../../core/constraint/so-delete-constraint';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteConstraint extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteConstraint;
}